import React ,{useEffect} from 'react'
import { Outlet, useLocation } from "react-router";
import Header from './Header';
import Footer from './Footer'
import { Sidebar } from './SideBar/Sidebar.jsx';
function Mainlayout() {
  const location = useLocation()
    useEffect(()=>{
      window.scrollTo({top:'0',behavior:'instant'})
    },[location.pathname])
  return (
    <>
      <Header />
     
      <Sidebar name={'button'} placement='end'/>
      <Outlet />
      <Footer />
    </>
  )
}

export default Mainlayout